export default function($log, $window, $state, ApiClass, ProfileClass, Swal) {
  'ngInject';

  const vm = this;

  const {
    profile: { profile_uid }
  } = ProfileClass.profileComplete;

  vm.$onInit = activate;

  vm.acceptBtn = invite => {
    vm.acceptBtnLadda = true;
    return Swal.confirm(
      'Accept invitation?',
      `Your account will be moved to ${
        invite.company_name
      } and you will no longer have access to company-specific information in your current account.  You will still have access your personal data.`
    )
      .then(() => {
        return ApiClass.usersIdTypeTypeIdPatch(
          { id: profile_uid, type: 'invites', type_id: invite.company_id },
          { accepted: true },
          {}
        ).then(() => {
          vm.acceptBtnLadda = false;
          $window.location.reload();
          Swal.toast(`You are now part of the ${invite.company_name} account.`);
        });
      })

      .catch(error => {
        vm.acceptBtnLadda = false;
        $log.error(error);
        throw error;
      });
  };

  vm.rejectBtn = invite => {
    vm.rejectBtnLadda = true;

    return Swal.confirm(
      'Reject invitation?',
      `Your profile will be left unchanged and the administrator from ${
        invite.company_name
      } will be notified that you've declined the invitation to join their account.`
    )
      .then(() => {
        return ApiClass.usersIdTypeTypeIdPatch(
          { id: profile_uid, type: 'invites', type_id: invite.company_id },
          { rejected: true },
          {}
        )
          .then(() => {
            Swal.toast(`Request to join ${invite.company_name} was rejected`);
            vm.rejectBtnLadda = false;
            return ProfileClass.profileGet(profile_uid);
          })
          .then(() => $state.reload());
      })
      .catch(error => {
        vm.rejectBtnLadda = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Firm Invites CTRL Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alertsCtrl/alerts/firmInvite/controller.js